import React from "react";
import clsx from "clsx";
import I18n from "i18n-js";

export default class PropertyDetailsPresenterLocks extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var tabClasses = clsx({
      active: this.props.active_tab == "locks",
      "tab-pane": true,
    });

    return (
      <div className={tabClasses} id="locks">
        <div className="row">
          <div className="col-md-4">
            {this.props.remotelock_refresh_token ? (
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "15px",
                  display: "inline-block",
                  padding: "10px 15px",
                  border: "1px solid #CFCFCF",
                  marginBottom: "5px",
                }}
              >
                <strong
                  style={{
                    fontWeight: "bold",
                    color: "green",
                    marginRight: "5px",
                  }}
                >
                  ✓{" "}
                </strong>
                {I18n.t("connected_to_your_remotelock_account")}
              </div>
            ) : (
              I18n.t("not_connected_to_your_remotelock_account")
            )}
          </div>
          <div className="col-md-4">
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>
                {I18n.t("remotelock_grace_period")}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("remotelock_grace_period_helper_text")}
                ></span>
              </label>
              <div>{this.props.remotelock_grace_period_in_minutes}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
